const config = {
    /* Your Tawk.to property ID */
    propertyId: null,
    /* Your Tawk.to widget ID */
    widgetId: null
};

/**
 * Get Tawk_API instance from window
 * @return {Object|undefined} Tawk_API object or undefined if not loaded
 */
function getTawkAPI() {
    return window.Tawk_API;
}

/**
 * Tawk.to chat analytics plugin
 * @link https://www.tawk.to/
 * @param {object}  pluginConfig - Plugin settings
 * @param {string}  pluginConfig.propertyId - Your Tawk.to property ID
 * @param {string}  pluginConfig.widgetId - Your Tawk.to widget ID
 * @return {object} Analytics plugin
 * @example
 *
 * tawktoPlugin({
 *   propertyId: 'your-property-id',
 *   widgetId: 'your-widget-id'
 * })
 */
function tawktoPlugin(pluginConfig = {}) {
    return {
        name: 'tawkto',
        config: {
            ...config,
            ...pluginConfig
        },
        methods: {
            shutdown() {
                const tawkAPI = getTawkAPI();
                if (typeof tawkAPI === 'undefined') return;
                if (typeof tawkAPI.hideWidget === 'function') {
                    tawkAPI.hideWidget();
                }
            },
            show() {
                const tawkAPI = getTawkAPI();
                if (typeof tawkAPI === 'undefined') return;
                if (typeof tawkAPI.showWidget === 'function') {
                    tawkAPI.showWidget();
                }
            },
            hide() {
                const tawkAPI = getTawkAPI();
                if (typeof tawkAPI === 'undefined') return;
                if (typeof tawkAPI.hideWidget === 'function') {
                    tawkAPI.hideWidget();
                }
            }
        },
        /* Load Tawk.to widget on page */
        initialize: ({ config }) => {
            const { propertyId, widgetId } = config;
            if (!propertyId) {
                throw new Error('No Tawk.to propertyId provided');
            }
            if (!widgetId) {
                throw new Error('No Tawk.to widgetId provided');
            }

            if (!document.getElementById('tawktoScript')) {
                window.Tawk_API = window.Tawk_API || {};
                window.Tawk_LoadStart = new Date();

                const tawktoScript = document.createElement('script');
                tawktoScript.id = 'tawktoScript';
                tawktoScript.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
                tawktoScript.async = true;
                tawktoScript.charset = 'UTF-8';
                tawktoScript.setAttribute('crossorigin', '*');
                document.head.appendChild(tawktoScript);
            } else {
                const tawkAPI = getTawkAPI();
                if (tawkAPI && typeof tawkAPI.showWidget === 'function') {
                    tawkAPI.showWidget();
                }
            }
        },
        /* Trigger Tawk.to page view */
        page: () => {
            const tawkAPI = getTawkAPI();
            if (typeof tawkAPI === 'undefined') return;
        },
        /* Track Tawk.to event */
        track: ({ payload }) => {
            const tawkAPI = getTawkAPI();
            if (typeof tawkAPI === 'undefined') return;
            if (typeof tawkAPI.addEvent === 'function') {
                tawkAPI.addEvent(payload.event, payload.properties);
            }
        },
        /* Remove Tawk.to on analytics.reset */
        reset: () => {
            const tawkAPI = getTawkAPI();
            if (typeof tawkAPI === 'undefined') return;
            if (typeof tawkAPI.hideWidget === 'function') {
                tawkAPI.hideWidget();
            }
        },
        /* Check if Tawk.to loaded */
        loaded: () => {
            return getTawkAPI();
        }
    };
}

export default tawktoPlugin;
